/**
 * Window is not available in SSR environments. This function provides safe access to it.
 */
export const safeWindow = <T = {}>(): (Window & typeof globalThis & T) | undefined =>
  'window' in globalThis ? (globalThis.window as Window & typeof globalThis & T) : undefined;
